// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  VisualAssetSource,
} from "./types";


export default __t.row({
  dtmi: __t.string().primaryKey(),
  assetPath: __t.string().name("asset_path"),
  get assetSource() {
    return VisualAssetSource.name("asset_source");
  },
  assetModuleAssetId: __t.option(__t.u64()).name("asset_module_asset_id"),
});
